/* Verfuegbarkeit: Zeilen, Mein Gwandhaus, Reservierung (r67, SJ 26.08)
   ────────────────────────────────────────────────────────────────────
   Die PDP (product-form.js) und die Schnellansicht (quick-view.js) zeichnen
   dieselben Geschaeftszeilen in dieselbe Modal-Huelle. Vor r67 lag der
   Zeilen-Renderer zweimal im Theme und ist bereits auseinandergelaufen; die
   Reservierung waere die dritte Kopie geworden. Hier steht sie einmal.

   Aufrufer bekommen einen Controller (attach) und rufen nur noch
   render(stores) / message(html) / reset(). Alles andere - Sortierung,
   Favorit, Seite 2, Versand - passiert hier drin.

   Reserviert wird NICHT mehr per mailto: die Anfrage geht an den Worker,
   der die Adresse des Geschaefts serverseitig aufloest (siehe
   goessl-partner /api/public/reserve). Der Browser kennt sie gar nicht. */
(function () {
  var ENDPOINT = 'https://partner.goessl.com/api/public/reserve';
  var STAV = 'https://gwandl-mcp.g-ssl.workers.dev/storefront/store-availability';
  var answers = {};   // Antworten je Anfrage-URL, 300 s wie im Worker - PDP und Schnellansicht teilen sie
  var FAV_KEY = 'goessl:favStore';

  /* ── Turnstile (r193, lead 05.10) ──────────────────────────────────
     Ohne Pruefung koennte jede Seite den Endpunkt aufrufen und jedem
     Geschaeft Post mit beliebiger Antwortadresse schicken. Das Portal
     verlangt deshalb ein Turnstile-Token, sobald sein Schalter
     reserve_turnstile_required an ist. Den Site-Key nennt das Portal
     (/api/public/reserve-stores, wie beim Vorbestell-Formular); ohne Key -
     Portal nicht erreichbar - geht die Anfrage ohne Token, was nur
     funktioniert, solange der Schalter aus ist. preorder-reserve.js laedt
     das Skript ueber dasselbe Versprechen, also nie doppelt. */
  var TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  var STORES_URL = 'https://partner.goessl.com/api/public/reserve-stores';
  var sitekeyReq = null;
  function turnstileSitekey() {
    if (!sitekeyReq) {
      sitekeyReq = fetch(STORES_URL, { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return (j && j.sitekey) || ''; })
        .catch(function () { sitekeyReq = null; return ''; });
    }
    return sitekeyReq;
  }
  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (!window.__g26TurnstileLoading) {
      window.__g26TurnstileLoading = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = TURNSTILE_SRC;
        s.async = true;
        s.onload = function () { if (window.turnstile) resolve(window.turnstile); else reject(new Error('turnstile')); };
        s.onerror = function () { window.__g26TurnstileLoading = null; reject(new Error('turnstile')); };
        document.head.appendChild(s);
      });
    }
    return window.__g26TurnstileLoading;
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function slug(v) {
    return String(v == null ? '' : v).replace(/[^a-z0-9-]/gi, '');
  }

  /* ── Mein Gwandhaus ────────────────────────────────────────────────
     Nur der Seiten-Slug wird gemerkt; Name und Stadt kommen ohnehin bei
     jedem Aufruf frisch vom Verfuegbarkeits-Endpunkt. Privater Modus oder
     gesperrter Speicher darf nichts kaputtmachen - daher try/catch. */
  function favGet() {
    try { return localStorage.getItem(FAV_KEY) || null; } catch (e) { return null; }
  }
  function favSet(page) {
    try {
      if (page) localStorage.setItem(FAV_KEY, page);
      else localStorage.removeItem(FAV_KEY);
    } catch (e) { /* kein Speicher, kein Favorit - sonst nichts */ }
  }

  // Das QR-Geschaeft schlaegt den Favoriten: wer gerade im Laden steht,
  // will diesen Laden oben sehen, nicht den von letzter Woche.
  function ctxPage() {
    var c = window.GoesslStoreMode && window.GoesslStoreMode.get();
    return (c && c.page) ? slug(c.page) : null;
  }

  function rank(page, ctx, fav) {
    if (ctx && page === ctx) return 2;
    if (fav && page === fav) return 1;
    return 0;
  }

  // "das Gwandhaus" traegt seinen Artikel selbst, alle anderen heissen
  // "Goessl <Stadt>" - beides liest sich im Satz sauber.
  function storeLabel(s) {
    if (slug(s.page) === 'goessl-im-gwandhaus') return window.g26t('stores.reserve.gwandhaus_label', 'das Gwandhaus');
    return 'Gössl ' + (s.city || s.name || '');
  }
  function storeTitle(s) {
    return s.name && s.name !== s.city ? s.name : (s.city || s.name || '');
  }

  /* ── Groessen je Geschaeft (Frau Adler 06.10.2026) ──────────────────
     Kundinnen sahen, welches Geschaeft das Modell hat, aber nicht in
     welcher Groesse. Die Liste fragt deshalb alle Groessen der gewaehlten
     Farbe ab; jedes Geschaeft nennt in `variants`, welche davon es hat.
     colourSizes: jede Variante, die in allen Optionen ausser Größe der
     Auswahl entspricht (Farbe, bei Lederhosen auch der Schnitt), in der
     Reihenfolge und mit der Beschriftung des Groessenrasters.
       variants = [{ id, options }], sel = gewaehlte Optionswerte (Index wie
       options), si = Index von Größe, grid = [{ value, label }] wie die
       Groessenknoepfe stehen. */
  function colourSizes(variants, sel, si, grid) {
    var pos = {};
    grid.forEach(function (g, i) { pos[g.value] = i; });
    return (variants || []).filter(function (v) {
      return Object.prototype.hasOwnProperty.call(pos, v.options[si]) &&
        v.options.every(function (o, i) { return i === si || o === sel[i]; });
    }).sort(function (a, b) {
      return pos[a.options[si]] - pos[b.options[si]];
    }).map(function (v) {
      return { id: String(v.id), label: grid[pos[v.options[si]]].label };
    });
  }

  // "Größen: 36 · 38 · 46" - die gewaehlte Groesse hervorgehoben
  function sizesHtml(s, sizes) {
    if (!sizes) return '';
    var held = sizes.list.filter(function (z) { return s.variants.indexOf(z.id) !== -1; });
    if (!held.length) return '';
    return '<span class="g26-stav__sizes">' +
      window.g26t('products.store_availability.sizes_label', 'Größen:', { count: held.length }) + ' ' +
      held.map(function (z) {
        return z.id === sizes.selected
          ? '<strong class="g26-stav__size is-selected">' + esc(z.label) + '</strong>'
          : '<span class="g26-stav__size">' + esc(z.label) + '</span>';
      }).join(' · ') + '</span>';
  }

  function rowsHtml(stores, reservable, sizes) {
    var ctx = ctxPage(), fav = favGet();
    var sorted = stores.slice().sort(function (a, b) {
      return rank(slug(b.page), ctx, fav) - rank(slug(a.page), ctx, fav);
    });
    return sorted.map(function (s) {
      var page = slug(s.page);
      var isCtx = !!(ctx && page === ctx);
      var isFav = !!(fav && page === fav);
      var sameName = s.name === s.city;
      var nameHtml = sameName ? '' : (page
        ? '<a class="g26-stav__name" href="' + window.g26url('pages/' + page) + '">' + esc(s.name) + '</a>'
        : '<span class="g26-stav__name">' + esc(s.name) + '</span>');
      var cityHtml = (page && sameName)
        ? '<a class="g26-stav__city" href="' + window.g26url('pages/' + page) + '">' + esc(s.city) + '</a>'
        : '<span class="g26-stav__city">' + esc(s.city) + '</span>';
      var badge = isCtx ? '<span class="g26-stav__here">' + window.g26t('stores.you_are_here', 'Sie sind hier') + '</span>'
        : (isFav ? '<span class="g26-stav__here g26-stav__here--fav">' + window.g26t('sections.store_locator.favourite_badge', 'Mein Gwandhaus') + '</span>' : '');
      var favLabel = isFav ? window.g26t('sections.store_locator.favourite_unset', 'Nicht mehr mein Gwandhaus') : window.g26t('sections.store_locator.favourite_set', 'Als mein Gwandhaus wählen');
      // r74 (SJ 27.08, 23:11): Reservieren ist von Click & Collect ENTKOPPELT —
      // der Knopf erscheint fuer jedes Geschaeft mit Bestand. Der Endpunkt
      // liefert weiterhin `reservable` (Shopify-Abholstatus je Geschaeft);
      // soll die r73-Kopplung zurueck, haengt der Knopf wieder an
      // `s.reservable === true` - eine Zeile.
      // r166 (Felix 16.09.2026): Reservierung abgeschaltet - Kundinnen umgingen
      // Versandkosten, kamen nicht oder erst nach Wochen. Der Knopf erscheint nur,
      // wenn die Theme-Einstellung "Reservierung im Geschaeft anbieten" an ist
      // (window.G26_RESERVATIONS aus theme.liquid); die Verfuegbarkeit bleibt.
      // r186 (#531, Felix 28.09.2026): und nur fuer Stuecke in ihren ersten
      // 30 Tagen online - das sagt das Modal selbst (data-reservable, gesetzt
      // von reserve-window.liquid bzw. beim Oeffnen der Schnellansicht).
      var reserveHtml = (window.G26_RESERVATIONS === true && reservable === true)
        ? '<button type="button" class="g26-stav__reserve" data-stav-reserve>' + window.g26t('stores.reserve.button', 'Reservieren') + '</button>'
        : '';
      var sizeLine = sizesHtml(s, sizes);
      // Der gruene Punkt las sich fuer Kundinnen als "das Stueck ist dort": ein
      // Geschaeft mit nur anderen Groessen bekommt einen hohlen, grauen Punkt.
      var isOther = !!(sizes && s.variants.indexOf(sizes.selected) === -1);
      return '<div class="g26-stav__row' + (isCtx ? ' is-context' : '') + (isFav ? ' is-fav' : '') + (sizeLine ? ' has-sizes' : '') + (isOther ? ' is-other' : '') + '"' +
          ' data-stav-row data-page="' + esc(page) + '"' +
          ' data-city="' + esc(s.city || '') + '" data-name="' + esc(s.name || '') + '">' +
        '<span class="g26-stav__dot" aria-hidden="true"></span>' +
        '<span class="g26-stav__store">' + cityHtml + nameHtml + badge + sizeLine + '</span>' +
        '<button type="button" class="g26-stav__fav' + (isFav ? ' is-on' : '') + '" data-stav-fav' +
          ' aria-pressed="' + (isFav ? 'true' : 'false') + '" title="' + favLabel + '"' +
          ' aria-label="' + favLabel + '">' + (isFav ? '★' : '☆') + '</button>' +
        reserveHtml +
        '</div>';
    }).join('');
  }

  /* ── Controller je Modal ───────────────────────────────────────────
     Auf einer PDP existieren ZWEI Modale (das der Seite und das der
     Schnellansicht aus theme.liquid). Deshalb laeuft jede Suche ueber
     root, nie ueber document - sonst greift die eine Instanz in die
     Felder der anderen. */
  function attach(root, getCtx) {
    if (!root || root._resvCtrl) return root && root._resvCtrl;

    var list = root.querySelector('[data-stav-list]');
    var page1 = root.querySelector('[data-stav-page1]');
    var page2 = root.querySelector('[data-resv]');
    if (!list) return null;

    var stores = [];
    var current = null;    // gewaehltes Geschaeft fuer Seite 2
    var tsWidget = null;   // Turnstile-Widget dieses Modals, sobald gezeichnet
    var tsToken = '';

    function q(sel) { return page2 ? page2.querySelector(sel) : null; }
    function show(el, on) { if (el) { if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); } }

    // Ein Token gilt fuer EINE Anfrage: frisch bei jedem Oeffnen und nach jeder Ablehnung.
    function freshTurnstile() {
      tsToken = '';
      var box = q('[data-resv-turnstile]');
      if (!box) return;                                   // Gast-Ansicht: kein Formular
      if (tsWidget !== null) { try { window.turnstile.reset(tsWidget); } catch (e) {} return; }
      turnstileSitekey().then(function (key) {
        if (!key || tsWidget !== null) return null;
        return loadTurnstile().then(function (ts) {
          if (tsWidget !== null) return;
          show(box, true);
          tsWidget = ts.render(box, {
            sitekey: key,
            size: 'flexible',
            language: /^en/i.test(document.documentElement.lang || '') ? 'en' : 'de',
            action: 'reserve',
            callback: function (t) { tsToken = t; },
            'expired-callback': function () { tsToken = ''; },
            'error-callback': function () { tsToken = ''; },
          });
        });
      }).catch(function () { /* kein Widget - die Anfrage geht ohne Token */ });
    }
    // Wer schneller tippt als Turnstile antwortet, wartet ein paar Sekunden; ohne Widget sofort.
    function tokenSoon(ms) {
      return new Promise(function (resolve) {
        if (tsWidget === null) return resolve('');
        var until = Date.now() + ms;
        (function poll() {
          if (tsToken || Date.now() > until) return resolve(tsToken);
          setTimeout(poll, 200);
        })();
      });
    }

    // Die Erklaerzeile ("Diese Geschaefte haben die Groesse vorraetig") passt
    // nur zu einer Liste - bei leerer Liste verschwindet sie (Felix 08.09).
    var hint = root.querySelector('[data-stav-hint]');
    function showHint(on) { if (hint) { if (on) hint.removeAttribute('hidden'); else hint.setAttribute('hidden', ''); } }

    // sizes = { selected, list } solange die Liste Groessen zeigt (siehe load)
    var sizes = null;
    function render(next, nextSizes) {
      stores = Array.isArray(next) ? next : [];
      sizes = nextSizes || null;
      // Oben wie bisher die Geschaefte mit der gewaehlten Groesse, darunter
      // eigens die mit nur anderen Groessen dieser Farbe - ohne Reservieren,
      // denn die Reservierung gilt der gewaehlten Groesse.
      var here = sizes ? stores.filter(function (s) { return s.variants.indexOf(sizes.selected) !== -1; }) : stores;
      var other = sizes ? stores.filter(function (s) { return here.indexOf(s) === -1; }) : [];
      var otherHtml = other.length
        ? '<p class="g26-stav__group">' + window.g26t('products.store_availability.other_sizes', 'In anderen Größen') + '</p>' + rowsHtml(other, false, sizes)
        : '';
      if (!here.length) {
        // Felix 08.09: "unser Online-Shop liefert" stand auch bei online
        // ausverkauften Groessen. Der Aufrufer sagt per ctx.available, ob der
        // Online-Shop die Groesse hat; ohne Angabe bleibt der Satz neutral.
        var ctx = (getCtx && getCtx()) || {};
        var text = ctx.available === false
          ? window.g26t('products.store_availability.empty_nowhere', 'Die gewählte Größe ist derzeit weder online noch in einem Geschäft vorrätig. Lassen Sie sich benachrichtigen, sobald sie wieder verfügbar ist – das Feld dafür finden Sie unter der Größenauswahl.')
          : ctx.available === true
            ? window.g26t('products.store_availability.empty_online_available', 'Die gewählte Größe ist derzeit in keinem Geschäft vorrätig – unser Onlineshop liefert Ihnen das Modell gerne nach Hause.')
            : window.g26t('products.store_availability.empty_no_store', 'Die gewählte Größe ist derzeit in keinem Geschäft vorrätig.');
        showHint(false);
        list.innerHTML = '<p class="g26-stav__empty">' + text + '</p>' + otherHtml;
        return;
      }
      showHint(true);
      // Bei jedem Zeichnen frisch gelesen: die Schnellansicht setzt das Attribut
      // je Produkt neu, bevor sie die Liste laedt.
      list.innerHTML = rowsHtml(here, root.getAttribute('data-reservable') === 'true', sizes) + otherHtml;
    }

    function message(html) { showHint(true); list.innerHTML = html; }

    /* Laden + Zeichnen fuer PDP und Schnellansicht.
       variant = die gewaehlte Variante ('' = Farbe und Groesse ohne Variante);
       sizeList = colourSizes(...) der gewaehlten Farbe oder null (keine
       Groessenwahl). Eine Farbe ist EINE Anfrage: ein Groessenwechsel
       zeichnet aus dem Speicher neu. Mehr als 30 Groessen (der Endpunkt nimmt
       30; heute hat eine Farbe hoechstens 16) oder eine Antwort ohne
       stores[].variants fragen wie frueher nur die gewaehlte Variante. */
    var pending = '';
    function load(variant, sizeList) {
      var useList = !!(sizeList && sizeList.length && sizeList.length <= 30 && !(sizeList.length === 1 && sizeList[0].id === variant));
      var ids = useList ? sizeList.map(function (z) { return z.id; }) : (variant ? [variant] : []);
      if (!ids.length) { message(window.g26t('products.store_availability.choose_size_first', 'Bitte wählen Sie zuerst eine Größe.')); return; }
      var url = STAV + (useList ? '?variants=' : '?variant=') + ids.join(',');
      pending = url;
      function draw(st) {
        if (useList && !st.every(function (s) { return Array.isArray(s.variants); })) { load(variant, null); return; }
        render(st, useList ? { selected: variant, list: sizeList } : null);
      }
      var hit = answers[url];
      if (hit && Date.now() - hit.t < 300000) { draw(hit.stores); return; }
      message('<p class="g26-stav__empty">' + window.g26t('products.store_availability.checking', 'Verfügbarkeit wird geprüft …') + '</p>');
      fetch(url)
        .then(function (r) { if (!r.ok) throw new Error('stav ' + r.status); return r.json(); })
        .then(function (j) {
          answers[url] = { t: Date.now(), stores: (j && j.stores) || [] };
          if (pending === url) draw(answers[url].stores);   // inzwischen andere Farbe gewaehlt: nicht zeichnen
        })
        .catch(function () {
          if (pending === url) message('<p class="g26-stav__empty">' + window.g26t('products.store_availability.load_error', 'Die Verfügbarkeit kann gerade nicht geladen werden – unsere Geschäfte helfen Ihnen telefonisch gerne weiter.') + '</p>');
        });
    }

    function reset() {
      current = null;
      show(page2, false);
      show(page1, true);
      show(q('[data-resv-ok]'), false);
      show(q('[data-resv-err]'), false);
      show(q('[data-resv-form]'), true);
      show(q('[data-resv-ctx]'), true);
      show(q('[data-resv-intro]'), true);
      var btn = q('[data-resv-submit]');
      if (btn) { btn.disabled = false; btn.textContent = window.g26tText('stores.reserve.submit', 'Anfrage senden'); }
    }

    function openForm(store) {
      if (!page2) return;
      current = store;
      var ctx = (getCtx && getCtx()) || {};
      var title = q('[data-resv-title]');
      if (title) title.textContent = window.g26tText('stores.reserve.title_for_store', 'Reservierung – {{ store }}', { store: storeTitle(store) });

      var dl = q('[data-resv-ctx]');
      if (dl) {
        var pairs = [
          [window.g26t('stores.reserve.item', 'Artikel'), ctx.title || ''],
          [window.g26t('products.product.article_number', 'Artikelnummer'), ctx.articleNo || ''],
          [window.g26t('stores.reserve.color', 'Farbe'), ctx.color || ''],
          [window.g26t('products.size_fit.size', 'Größe'), ctx.size || ''],
          [window.g26t('stores.reserve.store', 'Geschäft'), storeTitle(store) + (store.city && store.city !== store.name ? ', ' + store.city : '')],
        ];
        dl.innerHTML = pairs.filter(function (p) { return p[1]; }).map(function (p) {
          return '<div class="g26-resv__ctx-row"><dt>' + esc(p[0]) + '</dt><dd>' + esc(p[1]) + '</dd></div>';
        }).join('');
      }

      // Angemeldet-Fall: nach dem Login soll die Kundin wieder auf dem
      // Produkt landen, nicht auf der Seite, von der sie geklickt hat.
      if (ctx.handle) {
        // the variant being reserved comes back with her (colour and size, 22.10.2026)
        var back = encodeURIComponent(window.g26url('products/' + slug(ctx.handle)) + (ctx.variantId ? '?variant=' + encodeURIComponent(ctx.variantId) : ''));
        var login = q('[data-resv-login]'), reg = q('[data-resv-register]');
        if (login) login.href = window.g26url('account/login') + '?return_to=' + back;
        if (reg) reg.href = window.g26url('account/register') + '?return_to=' + back;
      }

      show(page1, false);
      show(page2, true);
      freshTurnstile();
      var focusable = q('[data-resv-name]') || q('[data-resv-login]');
      if (focusable) { try { focusable.focus(); } catch (e) {} }
    }

    function submit() {
      var btn = q('[data-resv-submit]');
      var okEl = q('[data-resv-ok]'), errEl = q('[data-resv-err]');
      var nameEl = q('[data-resv-name]'), mailEl = q('[data-resv-email]'), msgEl = q('[data-resv-msg]');
      if (!btn || !current) return;

      var name = nameEl ? nameEl.value.trim() : '';
      var email = mailEl ? mailEl.value.trim() : '';
      if (!name || !email || email.indexOf('@') < 0) {
        show(errEl, true);
        if (errEl) errEl.textContent = window.g26tText('stores.reserve.error_fields', 'Bitte prüfen Sie Name und E-Mail-Adresse.');
        return;
      }

      show(errEl, false);
      btn.disabled = true;
      btn.textContent = window.g26tText('stores.reserve.sending', 'Wird gesendet …');

      var ctx = (getCtx && getCtx()) || {};
      // Damit sich die Strecke am lebenden Shop prüfen lässt, ohne einem
      // echten Geschäft Post zu schicken: eine @asksj.com-Adresse markiert
      // die Anfrage als Test, der Worker leitet sie dann an sj@asksj.com um.
      // Die Domainprüfung passiert dort noch einmal — ein vorgetäuschtes
      // test:true von einer Kundenadresse geht trotzdem ins Geschäft.
      var isTest = /@asksj\.com$/i.test(email);
      tokenSoon(8000).then(function (tok) {
        return fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            test: isTest,
            page: slug(current.page),
            name: name,
            email: email,
            message: msgEl ? msgEl.value : '',
            title: ctx.title || '',
            article_no: ctx.articleNo || '',
            color: ctx.color || '',
            size: ctx.size || '',
            handle: ctx.handle || '',
            variant_id: ctx.variantId || '',
            turnstile: tok,
          }),
        });
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok || !res.body || !res.body.ok) {
            // Die Sicherheitspruefung in der Sprache des Shops, nicht im Deutsch des Portals.
            if (res.body && res.body.code === 'turnstile') throw new Error(window.g26t('stores.preorder_reserve.error_turnstile', 'Die Sicherheitsprüfung hat nicht geklappt – bitte laden Sie die Seite neu.'));
            throw new Error((res.body && res.body.error) || '');
          }
          if (okEl) okEl.textContent = window.g26tText('stores.reserve.success', 'Ihre Anfrage ist unterwegs – {{ store }} meldet sich bei Ihnen.', { store: storeLabel(current) });
          show(okEl, true);
          // Der Erfolgsschirm trägt nur noch den Satz: Formular, Kontexttabelle
          // und der erklärende Vorspann haben ihre Arbeit getan.
          show(q('[data-resv-form]'), false);
          show(q('[data-resv-ctx]'), false);
          show(q('[data-resv-intro]'), false);
        })
        .catch(function (e) {
          btn.disabled = false;
          btn.textContent = window.g26tText('stores.reserve.submit', 'Anfrage senden');
          if (errEl) {
            errEl.textContent = e && e.message
              ? e.message
              : window.g26tText('stores.reserve.error_generic', 'Das hat leider nicht geklappt – bitte versuchen Sie es gleich noch einmal.');
          }
          show(errEl, true);
          freshTurnstile();
        });
    }

    // Delegiert: die Liste wird bei jedem Variantenwechsel neu gezeichnet.
    list.addEventListener('click', function (e) {
      var favBtn = e.target.closest('[data-stav-fav]');
      if (favBtn) {
        var favRow = favBtn.closest('[data-stav-row]');
        var page = favRow && favRow.dataset.page;
        if (!page) return;
        favSet(favGet() === page ? null : page);
        render(stores, sizes);
        // r68: page-level stars + the PDP store line share the favourite
        if (window.GoesslFavStore) window.GoesslFavStore.paint();
        return;
      }
      var resBtn = e.target.closest('[data-stav-reserve]');
      if (!resBtn) return;
      var row = resBtn.closest('[data-stav-row]');
      if (!row) return;
      openForm({ page: row.dataset.page, city: row.dataset.city, name: row.dataset.name });
    });

    if (page2) {
      var backBtn = page2.querySelector('[data-resv-back]');
      if (backBtn) backBtn.addEventListener('click', reset);
      var submitBtn = page2.querySelector('[data-resv-submit]');
      if (submitBtn) submitBtn.addEventListener('click', submit);
    }

    var ctrl = { render: render, load: load, message: message, reset: reset, root: root };
    root._resvCtrl = ctrl;
    return ctrl;
  }

  window.GoesslReserve = {
    attach: attach,
    rows: rowsHtml,
    colourSizes: colourSizes,
    fav: { get: favGet, set: favSet },
  };
})();
